module.exports = __webpack_public_path__ + "img/icons-zhpj-quality.50fc14ce.png";